import angular from 'angular';
import { routes } from './routes';
import { react2angular } from 'react18-react2angular';
import CrmCotacaoForm from '../cotacoes/form';
import { useContext } from '@components';
import CrmCotacoesListView from './list';
export default angular.module('app.crm.cotacoes', [])
    .config(routes)
    .component("crmCotacaoForm", react2angular(useContext.use(CrmCotacaoForm), [], ["$state", "CrmService", "AuthorizationService"]))
    .component('crmCotacoesListView', react2angular(useContext.use(CrmCotacoesListView), [], ['$state', 'CrmService', "UIService"]))
    .name;
